import React from "react";
import MaskebariTable from "./MaskebariTable";

const index = () => {
  return (
    <div>
      <MaskebariTable />
    </div>
  );
};

export default index;
